import React, { PropsWithChildren } from "react";
import { TeamScheduleAdminItemTimeContainerWidth } from "./TeamScheduleAdminItem";
import { Box, Circle, useLayoutContext } from "arkh";
import { TeamScheduleAdminItemAddIcon } from "./TeamScheduleAdminItemAddIcon";
import { Pressable } from "react-native";
import Animated, {
  SharedValue,
  useAnimatedStyle,
} from "react-native-reanimated";

export function TeamScheduleAdminItemAddContainer(
  props: PropsWithChildren<{
    index: number;
    touchableOpacityAnimation: SharedValue<number | null>;
    isFirst: boolean;
    isLast: boolean;
    onPressInBefore: () => void;
    onPressInAfter: () => void;
    onPressOut: () => void;
    onPressAddBefore: () => void;
    onPressAddAfter: () => void;
  }>
) {
  const beforeAnimationStyle = useAnimatedStyle(() => ({
    opacity:
      props.touchableOpacityAnimation.value === props.index - 1 ? 0.3 : 1,
  }));
  const afterAnimationStyle = useAnimatedStyle(() => ({
    opacity: props.touchableOpacityAnimation.value === props.index ? 0.3 : 1,
  }));
  const layout = useLayoutContext();
  return (
    <>
      <Box>
        {props.children}
        {props.isFirst ? null : (
          <Pressable
            style={{
              position: "absolute",
              flexDirection: "column-reverse",
              top: 0,
              paddingBottom: layout.space.medium,
              paddingHorizontal: layout.space.medium,
              height: layout.circle.large / 2 + layout.space.medium,
              overflow: "hidden",
              zIndex: 100,
              left:
                TeamScheduleAdminItemTimeContainerWidth / 2 -
                layout.circle.large / 2,
            }}
            hitSlop={{ top: 0, left: 20, right: 20, bottom: 20 }}
            pressRetentionOffset={{ top: 0, left: 20, right: 50, bottom: 20 }}
            onPressIn={props.onPressInBefore}
            onPress={props.onPressAddBefore}
            onPressOut={props.onPressOut}
          >
            <Circle size="large" color="surface-primary">
              <Animated.View style={[beforeAnimationStyle]}>
                <TeamScheduleAdminItemAddIcon />
              </Animated.View>
            </Circle>
          </Pressable>
        )}
        <Pressable
          style={{
            position: "absolute",
            zIndex: 100,
            height: layout.circle.large / 2 + layout.space.medium,
            bottom: 0,
            paddingTop: layout.space.medium,
            paddingHorizontal: layout.space.medium,
            left:
              TeamScheduleAdminItemTimeContainerWidth / 2 -
              layout.circle.large / 2,
            overflow: "hidden",
          }}
          hitSlop={{ top: 20, left: 20, right: 20, bottom: 0 }}
          pressRetentionOffset={{ top: 20, left: 20, right: 50, bottom: 0 }}
          onPressIn={props.onPressInAfter}
          onPress={props.onPressAddAfter}
          onPressOut={props.onPressOut}
        >
          <Circle size="large" color="surface-primary">
            <Animated.View style={[afterAnimationStyle]}>
              <TeamScheduleAdminItemAddIcon />
            </Animated.View>
          </Circle>
        </Pressable>
      </Box>
      {props.isLast ? (
        <Box style={{ height: layout.circle.large / 2 + layout.space.medium }}>
          <Pressable
            style={{
              position: "absolute",
              flexDirection: "column-reverse",
              zIndex: 100,
              height: layout.circle.large / 2 + layout.space.medium,
              top: 0,
              paddingBottom: layout.space.medium,
              paddingHorizontal: layout.space.medium,
              left:
                TeamScheduleAdminItemTimeContainerWidth / 2 -
                layout.circle.large / 2,
              overflow: "hidden",
            }}
            hitSlop={{ top: 20, left: 20, right: 20, bottom: 0 }}
            pressRetentionOffset={{ top: 20, left: 20, right: 50, bottom: 0 }}
            onPressIn={props.onPressInAfter}
            onPress={props.onPressAddAfter}
            onPressOut={props.onPressOut}
          >
            <Circle
              size="large"
              color="surface-primary"
              borderColor="border-primary"
              borderWidth={1}
            >
              <Animated.View style={[afterAnimationStyle]}>
                <TeamScheduleAdminItemAddIcon />
              </Animated.View>
            </Circle>
          </Pressable>
        </Box>
      ) : null}
    </>
  );
}
